

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import { supremeCourtCaseJsonDataInfoType, supremeCourtOrdersJsonInfoType } from '@/types/Information/json';
import Spinner from "@/components/utils/Spinner.vue";
import Form1SearchOrderDetails from "./Form1SearchOrderDetails.vue";
import { locationsInfoType } from '@/types/Common';
import { form1DataInfoType, form1SearchInfoType } from '@/types/Information/Form1';

@Component({
    components: {           
        Spinner,
        Form1SearchOrderDetails
    }        
}) 
export default class Form1CaseInformationSearch extends Vue {

    @informationState.Action
    public UpdateSupremeCourtCaseJson!: (newSupremeCourtCaseJson: supremeCourtCaseJsonDataInfoType) => void

    @informationState.Action
    public UpdateCaseLocation!: (newCaseLocation: locationsInfoType) => void

    @informationState.Action
    public UpdateSupremeCourtOrderJson!: (newSupremeCourtOrderJson: supremeCourtOrdersJsonInfoType) => void

    @commonState.State
    public locationsInfo!: locationsInfoType[];

    @form1State.State
    public form1Info: form1DataInfoType;

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void
    
    inactiveButtonClass = "bg-secondary text-white"; 
    activeButtonClass = "bg-success text-white";
    levelOfCourt = "Supreme Court of BC";

    dataReady = false;
    searching = false;
    loadingOrders = false;
    noOrdersFound = false;    

    searchParams = {} as form1SearchInfoType;
    notFound = false;    
    cases: supremeCourtCaseJsonDataInfoType[];

    caseFields =  
    [
        {key:'styleOfCause', label:'', cellStyle:'', cellClass:''}
    ];

    mounted(){
        this.dataReady = false;
        this.cases = [];        
        this.searching = false;
        this.dataReady = true; 
    }

    public findFile(){

        this.searching = true;        
        this.notFound = false;
        
        const url = '/file-detail/?'+
            'courtLevel=S'+
            '&locationId='+ this.searchParams.location +
            '&fileNumber='+ this.searchParams.file; 
        
        this.$http.get(url)
        .then(res => {
            this.searching = false;
            if(res.data){
                this.cases = res.data;
                if(this.cases.length==1){
                    this.cases[0]['_showDetails'] = true;
                    this.getOrders(this.cases[0])
                }
            } else {
                this.notFound = true;
            }
            Vue.filter('scrollInto')('results-table')
                
        },err => {
            console.error(err); 
            this.notFound = true;  
            this.searching = false;
        });
    }

    public OpenDetails(data)
    {
        console.log(data.item)
        if(!data.detailsShowing)
        {
            this.getOrders(data.item)            
        }       
    }

    public getOrders(caseInfo: supremeCourtCaseJsonDataInfoType){

        this.loadingOrders = true;        
        this.noOrdersFound = false;
        
        const url = '/file-detail/orders/'+ caseInfo.fileId; 
        
        this.$http.get(url)
        .then(res => {
            
            if(res.data){                
                const orders = res.data;
                caseInfo.orders = orders
                this.UpdateSupremeCourtCaseJson(caseInfo)           
                const selectedLocation: locationsInfoType = this.locationsInfo.filter(location=>location.id == this.searchParams.location)[0]
                this.UpdateCaseLocation(selectedLocation);
                this.loadingOrders = false;

            } else {
                this.UpdateSupremeCourtCaseJson(null);
                this.UpdateSupremeCourtOrderJson(null);
                this.noOrdersFound = true;
            }
            Vue.filter('scrollInto')('results-table')
                
        },err => {
            console.error(err); 
            this.noOrdersFound = true;  
            this.loadingOrders = false;
           
        });
    }

    public navigateToForm1() {

        const form1SubmissionData = this.form1Info;
        form1SubmissionData.parties = [];
        form1SubmissionData.requiresManualEntry = true;
       
        this.UpdateForm1Info(form1SubmissionData);
        this.selectOrder();
    }

    public selectOrder(){
        const locationName = this.locationsInfo.filter(location => {return location.id == this.searchParams.location})[0].name;
        this.$emit('fillForm', this.levelOfCourt, this.searchParams.location, this.searchParams.file, locationName);
    }

    public supremeFileformatter(value){
        const courtClass = ['B', 'E', 'H', 'L', 'M', 'P', 'S', 'V'];
        const firstChar = value.slice(0,1).toUpperCase()
        
        if(courtClass.includes(firstChar)){
            if(isNaN(Number(value.slice(1))))
                return firstChar
            else
                return firstChar+value.slice(1)
        }
        if(isNaN(Number(value.slice(-1)))) return value.slice(0,-1)
        return value
    }
}
